import { validateCompanyTypes } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthState } from 'services/redux/authSlice';

import EnhancedTab from '../../lib/designSystem/TabSimulation';
import ExecutedEvaluations from './components/Executed';
import SharedEvaluations from './components/Shared';

const tabsAvailable = {
  executed: {
    label: 'Realizadas',
    component: <ExecutedEvaluations />,
    mainPage: 'executed',
  },
  shared: {
    label: 'Compartidas',
    component: <SharedEvaluations />,
    mainPage: 'shared',
  },
};

const CreditHubProEvaluations: React.FC = () => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [tabs, setTabs] = useState<any>([]);
  const navigate = useNavigate();

  const startValue = 0;
  const handleNavigation = (index: number) => {
    navigate(`/creditHubPro/${tabs[index].mainPage}/${tabs[index].subPage}`);
  };

  const setUp = () => {
    const newTabs: any = [];
    if (validateCompanyTypes(user, 'Fund')) {
      newTabs.push(tabsAvailable.shared);
    } else {
      newTabs.push(tabsAvailable.executed);
    }
    setTabs(newTabs);
  };

  useEffect(() => {
    setUp();
  }, [user]);

  return (
    <div>
      <EnhancedTab
        title={'Evaluaciones'}
        startValue={startValue}
        tabs={tabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default CreditHubProEvaluations;
